import { AppleIcon, GoogleIcon } from '~public'

export const StyledGoogleIcon = (props) => <GoogleIcon style={{ marginRight: props.marginRight }} />
export const StyledAppleIcon = (props) => <AppleIcon style={{ marginRight: props.marginRight }} />
